"use client";

import clsx from "clsx";
import type React from "react";
import Typography, { type TypographyTone } from "../../common/Typography/Typography";
import "./Label.css";

const styles: Record<string, string> = { label: "calmlens-label-label" };

export interface LabelProps extends React.HTMLAttributes<HTMLLabelElement> {
  as?: React.ElementType;
  tone?: TypographyTone;
  disabled?: boolean;
  required?: boolean;
  htmlFor?: string;
  /** `field` labels sit above a control; `option` labels sit beside a checkbox, radio or switch. */
  variant?: "field" | "option";
}

const Label = (props: LabelProps) => {
  const {
    as = "label",
    tone = "muted",
    disabled,
    required,
    children,
    className,
    htmlFor,
    variant = "field",
    ...otherProps
  } = props;

  return (
    <Typography
      as={as}
      variant="bodySmall"
      weight={variant === "option" ? "medium" : "semibold"}
      tone={variant === "option" ? "foreground" : tone}
      data-variant={variant}
      {...otherProps}
      htmlFor={htmlFor}
      aria-disabled={disabled ? "true" : undefined}
      className={clsx(styles.label, className)}
    >
      {children}
      {required ? (
        <span aria-hidden="true" style={{ color: "var(--color-accent)" }}>
          *
        </span>
      ) : null}
    </Typography>
  );
};

export default Label;
